import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.Filters = class Filters extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-form-filters';
    }

    constructor(element) {
        super(element);
    }

    render() {

        $("#pastEventsBtn").parent().removeClass("active");
        $("#upcomingEventsBtn").parent().removeClass("active");
        if (location.search == "?past=true")
        {
            $("#pastEventsBtn").parent().addClass("active");
            $("#upcomingEventsBtn").parent().removeClass("active");
        }
        else
        {
            $("#pastEventsBtn").parent().removeClass("active");
            $("#upcomingEventsBtn").parent().addClass("active");
        }

        $("#pastEventsBtn").on("click", function () {
            window.location = '/events?past=true';
        })

        $("#upcomingEventsBtn").on("click", function () {
            window.location = '/events';
        })

        var PAGE_SIZE = parseInt($('.fa-filter-content').first().data('page-size'));
        var currentVisibleItems = PAGE_SIZE;
        var totalFiltered = 0;
        $('select.filter-data').bind('change', function(e) {
            currentVisibleItems = PAGE_SIZE;
            filter(e);
            showHideButtons();
        });

        function filter(e, scroll){
            $('select.filter-data').attr('disabled', 'disabled');
            var filterAttribute = '';

            $('select.filter-data').each(function () {
                if ($(this).val() != '0') {
                    filterAttribute += '[data-' + $(this).data('attribute') + '="' + $(this).val() + '"]';
                }
            });

            var $allElements = $('.fa-filter-content').find('.fa-filter-content__item' + filterAttribute);
            totalFiltered = $allElements.length;
            if(totalFiltered == 0){
                $('.fa-filter-content').find('.fa-filter-content__item').hide();
                $('select.filter-data').removeAttr('disabled');
                $('.counter').html('There are no events available for your selected filter');
                return;
            }

            var $visibleElements = $allElements.slice(0, currentVisibleItems);
            var newTop = currentVisibleItems == PAGE_SIZE
                            ? $visibleElements.first().offset().top - ($(window).width() < 991 ? 50 : 150)
                            : $($visibleElements[currentVisibleItems - PAGE_SIZE - 1]).offset().top + $($visibleElements[currentVisibleItems - PAGE_SIZE - 1]).height() - ($(window).width() < 991 ? 50 : 150);
            var x = 0;
            $('.fa-filter-content').find('.fa-filter-content__item').hide();
            $visibleElements.fadeIn(10, function() {
                if(x < $visibleElements.length - 1){
                    x++;
                }
                else
                {
                    if(scroll)
                    {
                        $('body,html').animate({ scrollTop: newTop }, 500);
                    }
                }
            });


            var event_visible = $('.fa-filter-content .fa-filter-content__item:visible');
            if($(event_visible).length > 0){
                $('.counter').html(totalFiltered + ' events available');
            }
            $('select.filter-data').removeAttr('disabled');
        }

        function showHideButtons() {

            console.log('hi');
            if(currentVisibleItems >= totalFiltered)
            {
                $('#showMore').hide();
            }
            else
            {
                $('#showMore').show();
            }

            if(currentVisibleItems <= PAGE_SIZE)
            {
                $('#showLess').hide();
            }
            else
            {
                $('#showLess').show();
            }
        }

        $('#showMore').click(function (e) {
            currentVisibleItems += PAGE_SIZE;
            filter(e, true);
            showHideButtons();

        });

        $('#showLess').click(function (e) {
            currentVisibleItems -= PAGE_SIZE;
            filter(e, true);
            showHideButtons();
        });

        // this is to stop filter and showHidebuttons
        // from executing on meeting and events page. 
        if ($('.fa-form-meeting-events').length) {
            return false
        }
        

        filter();
        showHideButtons();


    }
}





// WEBPACK FOOTER //
// ./components/filters/scripts/filters.js